import Vue from 'vue';

const state = {
  unitTypes: {}
}

const getters = {

  unitType (state) {
    return id => {
      if (id in state.unitTypes) return state.unitTypes[id];
      else return false;
    }
  },

  unitTypes (state) {
    return state.unitTypes;
  }
}

const mutations = {

  storeUnitTypes (state, unitTypes) {
    
    unitTypes.forEach(unitType => {
      var current = state.unitTypes[unitType._id] || {};
      Vue.set(state.unitTypes, unitType._id, {
        ...current,
        ...unitType
      });
    });
  },

  removeUnitType (state, id) {
    if (id in state.unitTypes) Vue.delete(state.unitTypes, id);
  },

  clearUnitTypes () {
    Vue.set(state, 'unitTypes', {});
  }

}

const actions = {
  
  loadUnitTypes ({commit}, params) {
    
    var filters = params.filters || {};

    if (!params.property) {
      return Promise.reject('state.unitType - loading Unit Types - Missing required param "property"');
    }

    var queryParams = {
      ...filters
    };

    return window.server.getReq('property/' + params.property + '/unitTypes', {
      params: queryParams
    })
    .then(data => {
      commit('storeUnitTypes', data);
      return Promise.resolve(data);
    })
    .catch(e => {
      return Promise.reject(e);
    });

  },

  loadUnitType ({commit}, params) {
    
    if (!params.property) {
      return Promise.reject('state.unitType - loading Unit Types - Missing required param "property"');
    }
    if (!params.unitType) {
      return Promise.reject('state.unitType - loading Unit Types - Missing required param "unitType"');
    }

    return window.server.getReq('property/' + params.property + '/unitType/' + params.unitType, {})
    .then(data => {
      commit('storeUnitTypes', [data]);
      return Promise.resolve(data);
    })
    .catch(e => {
      return Promise.reject(e);
    });

  },

  createUnitType ({commit, dispatch}, params) {
    if (!params.property) {
      return Promise.reject('state.unitType - create Unit Types - Missing required param "property"');
    }
    else if (!params.unitType) {
      return Promise.reject('state.unitType - create Unit Types - Missing required param "unitType"');
    }

    return window.server.postReq('property/' + params.property + '/unitType', {
      unitType: params.unitType
    })
    .then(data => {
      return dispatch('loadUnitType', {
        property: params.property,
        unitType: data._id
      })
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  deleteUnitType ({commit, dispatch}, params) {
    if (!params.property) {
      return Promise.reject('state.unitType - create Unit Types - Missing required param "property"');
    }
    else if (!params.unitType) {
      return Promise.reject('state.unitType - create Unit Types - Missing required param "unitType"');
    }

    return window.server.delReq('property/' + params.property + '/unitType/' + params.unitType, {})
    .then(data => {
      commit('removeUnitType', params.unitType);
      return Promise.resolve(data);
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  updateUnitType ({commit, dispatch}, params) {
    if (!params.property) {
      return Promise.reject('state.property - update Property - Missing required param "property"', params);
    }
    if (!params.unitType) {
      return Promise.reject('state.property - update Property - Missing required param "unitType"', params.unitType);
    }

    return window.server.putReq('property/' + params.property + '/unitType/' + params.unitType._id, {
      unitType: params.unitType
    })
    .then(data => {
      return dispatch('loadUnitType', {
        property: params.property,
        unitType: params.unitType._id
      });
    })
    .catch(e => {
      return Promise.reject(e);
    });  
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/unitType.js